// libs
import React, { memo, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router';

// constants
import { BOTTOM_NAV_STATES, getBottomNavConfig, IBottomNavState } from './constants';

// components
import Portal from 'shared/components/Portal';

// styles
import { BottomNavItem, Container, IconContainer, Title, Image, containerCss } from './styles';

// defs
import { IBottomNavProps } from './types';

// store
import { getBottomNavOptions } from 'shared/store/app/selectors';
import { getRemoteConfig } from 'shared/store/remoteConfigs/selectors';

// context
import { useAppLayoutContext } from 'shared/layouts/AppLayout/AppLayoutContext';

// helpers
import { trackSelectedBottomNavState } from './analytics';
import { isWebView } from 'shared/helpers/utils/url';

function BottomNav({ showBottomNav, selectedBottomNavState, extraBNConfig }: IBottomNavProps) {
  const { setCSS } = useAppLayoutContext();
  const location = useLocation();

  const bottomNavStates = useMemo(() => {
    return getBottomNavConfig(extraBNConfig);
  }, [extraBNConfig]);

  useEffect(() => {
    if (showBottomNav && !isWebView(location)) {
      setCSS(containerCss);
    }

    return () => {
      if (showBottomNav) {
        setCSS(undefined);
      }
    };
  }, [location, setCSS, showBottomNav]);

  useEffect(() => {
    selectedBottomNavState && trackSelectedBottomNavState(selectedBottomNavState);
  }, [selectedBottomNavState]);

  if (showBottomNav === false || isWebView(location)) {
    return null;
  }

  const IconComponent = (item: IBottomNavState, isSelected: boolean) => {
    if (item.icon === undefined) {
      return isSelected ? (
        <Image src={item.selectedImage} alt={item.name} />
      ) : (
        <Image src={item.image} alt={item.name} className={item.name} />
      );
    }

    const iconClass = isSelected ? item.selectedIcon : item.icon;

    return <i className={iconClass} />;
  };

  const redirectTo = (actionUrl: string) => {
    window.location.href = actionUrl;
  };

  return (
    <Portal>
      <Container>
        {bottomNavStates.map((item, index) => {
          const isSelected = item.id === selectedBottomNavState;
          return (
            <BottomNavItem
              key={index}
              statesCount={BOTTOM_NAV_STATES.length}
              isSelected={item.id === selectedBottomNavState}
              onClick={() => redirectTo(item.url)}
            >
              <IconContainer>{IconComponent(item, isSelected)}</IconContainer>
              <Title>{item.name}</Title>
            </BottomNavItem>
          );
        })}
      </Container>
    </Portal>
  );
}

const mapStateToProps = (state: any) => {
  const bottomNavOptions = getBottomNavOptions(state);
  const extraBottomNavElement = getRemoteConfig(state, 'bottomNavSaleConfig');

  return { ...bottomNavOptions, extraBNConfig: extraBottomNavElement };
};
export default memo(connect(mapStateToProps)(BottomNav));
